<template>
  <v-card>
    <v-toolbar color="transparent" flat dense card>
      <v-toolbar-title>
        <h4 class="font-weight-regular">Training Per Bulan</h4>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <div class="caption" v-if="trendOn">
        <v-icon>{{ trend_icon }}</v-icon> {{ Math.abs(trend) }}%
      </div>
    </v-toolbar>
    <div
      v-if="training_init"
      class="layout justify-center align-center"
      style="min-height: 400px"
    >
      <v-progress-circular
        indeterminate
        :size="80"
        :width="4"
        color="secondary"
      >
      </v-progress-circular>
    </div>
    <template v-else>
      <v-card-text class="pa-0">
        <bar-chart :height="350" :chartData="monthlyTrainingChart"> </bar-chart>
        <div
          class="layout row align-center ma-0 px-3 py-2"
          :class="$vuetify.dark ? 'grey darken-3' : 'secondary'"
        >
          <div :class="$vuetify.dark ? 'white--text' : 'white--text'">
            <div class="caption">RERATA PER BULAN</div>
            <div class="subheading mt-2">{{ average }} Training</div>
          </div>
          <v-spacer></v-spacer>
          <v-progress-circular
            :size="100"
            :width="15"
            :rotate="100"
            :value="clients_progress"
            color="white"
          >
            {{ clients_progress }}%
          </v-progress-circular>
        </div>
      </v-card-text>
    </template>
  </v-card>
</template>

<script>
import Material from "vuetify/es5/util/colors";
// import EChart from "@/components/chart/echart";
import BarChart from "@/components/chart/BarChart";
import _ from "lodash";
import { mapGetters, mapState } from "vuex";

export default {
  name: "monthly-training",
  components: {
    // EChart
    BarChart
  },
  data() {
    return {
      color: Material
    };
  },
  computed: {
    ...mapState(["periode$"]),
    ...mapState("training", ["training_init"]),
    ...mapGetters("training", ["trainingByLaman"]),
    monthlyTrainingChart() {
      let trainings = this.$store.getters["training/trainingByLaman"];
      let months = this.$moment()._locale._monthsShort;
      let tipe = ["ON-SITE", "OFF-SITE"];
      // declare muli array
      let data = [];
      for (let i = 0; i < months.length; i++) {
        data[i] = [];
        for (let j = 0; j < tipe.length; j++) {
          data[i][tipe[j]] = [];
        }
      }
      // fill the array
      for (let i = 0; i < trainings.length; i++) {
        let time = this.$moment(
          trainings[i].waktu_mulai,
          "YYYY-MM-DD HH:mm:ss"
        );
        if (time.year() == this.periode$) {
          data[time.month()][trainings[i].pel_tipe].push(trainings[i]);
        }
      }
      return {
        labels: months.map(m => {
          return m;
        }),
        datasets: [
          {
            label: "ON-SITE",
            backgroundColor: this.$vuetify.theme.primary,
            data: months.map((m, i) => {
              return data[i]["ON-SITE"].length;
            })
          },
          {
            label: "OFF-SITE",
            backgroundColor: this.$vuetify.theme.secondary,
            data: months.map((m, i) => {
              return data[i]["OFF-SITE"].length;
            })
          },
          {
            label: "TOTAL",
            borderColor: this.$vuetify.dark ? "white" : "",
            type: "line",
            fill: false,
            data: months.map((m, i) => {
              return data[i]["ON-SITE"].length + data[i]["OFF-SITE"].length;
            })
          }
        ]
      };
    },
    monthlyTrainingData() {
      let trainings = this.$store.getters["training/trainingByLaman"];
      let months = this.$moment()._locale._monthsShort;
      let tipe = ["ON-SITE", "OFF-SITE"];
      // declare muli array
      let data = [];
      for (let i = 0; i < months.length; i++) {
        data[i] = [];
        for (let j = 0; j < tipe.length; j++) {
          data[i][tipe[j]] = [];
        }
      }
      // fill the array
      for (let i = 0; i < trainings.length; i++) {
        let time = this.$moment(
          trainings[i].waktu_mulai,
          "YYYY-MM-DD HH:mm:ss"
        );
        if (time.year() == this.periode$) {
          data[time.month()][trainings[i].pel_tipe].push(trainings[i]);
        }
      }
      // prepare the result
      let result = months.map((m, i) => {
        return {
          month: m,
          "ON-SITE": data[i]["ON-SITE"].length,
          "OFF-SITE": data[i]["OFF-SITE"].length,
          TOTAL: data[i]["ON-SITE"].length + data[i]["OFF-SITE"].length
        };
      });
      return result;
    },
    trendOn() {
      return this.periode$ == this.$moment().year();
    },
    trend() {
      let month = this.$moment().month();
      let trend = 0;
      if (month > 1) {
        let this_month = this.monthlyTrainingData[month];
        let last_month = this.monthlyTrainingData[month - 1];
        let this_total = this_month["ON-SITE"] + this_month["OFF-SITE"];
        let last_total = last_month["ON-SITE"] + last_month["OFF-SITE"];
        // eslint-disable-next-line
        trend = Math.round(((this_total - last_total) / last_total) * 100);
        if (isNaN(trend)) trend = 0;
      }
      return trend;
    },
    trend_icon() {
      let icon = "trending_flat";
      if (this.trend > 0) icon = "trending_up";
      else if (this.trend < 0) icon = "trending_down";
      return icon;
    },
    average() {
      let total = 0;
      for (let i = 0; i < this.monthlyTrainingData.length; i++) {
        let sum = parseInt(
          this.monthlyTrainingData[i]["ON-SITE"] +
            this.monthlyTrainingData[i]["OFF-SITE"]
        );
        total += sum;
      }
      return Math.round(total / (this.$moment().month() + 1));
    },
    clients_progress() {
      let clients = _.cloneDeep(
        this.$store.getters["client/clientByLamanPeriode"]
      );
      clients = clients.filter(c => {
        return parseInt(c.active_client);
      });
      let total_diff = 0;
      let total_target = 0;

      for (let i = 0; i < clients.length; i++) {
        total_target += parseInt(clients[i].target_per_tahun);
        let diff = parseInt(
          clients[i].target_per_tahun - clients[i].total_training
        );
        total_diff += diff < 0 ? 0 : diff;
      }
      // eslint-disable-next-line
      return Math.round(((total_target - total_diff) / total_target) * 100);
    }
  }
};
</script>

<style scoped>
.full {
  height: 350px;
  width: 100%;
}
</style>
